/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Student } from '../../models/student';
import { StudentLoginDto } from '../../models/student-login-dto';

export interface IlsControllerCreateStudent$Params {
  ilsId: string;
      body: StudentLoginDto
}

export function ilsControllerCreateStudent(http: HttpClient, rootUrl: string, params: IlsControllerCreateStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<Student>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerCreateStudent.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Student>;
    })
  );
}

ilsControllerCreateStudent.PATH = '/ils/{ilsId}/createStudent';
